import { render, staticRenderFns } from "./PolicyPrivacyPage.vue?vue&type=template&id=68d931a6&scoped=true"
import script from "./PolicyPrivacyPage.vue?vue&type=script&lang=js"
export * from "./PolicyPrivacyPage.vue?vue&type=script&lang=js"
import style0 from "./PolicyPrivacyPage.css?vue&type=style&index=0&id=68d931a6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d931a6",
  null
  
)

export default component.exports